import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isShow: false,
  modalData: {
    title: '',
    description: '',
    leftButtonTitle: '',
    rightButtonTitle: '',
    cancelButton: 'right',
  },
}

export const getIsShowSelector = (state) => state.confirmation.isShow
export const getModalDataSelector = (state) => state.confirmation.modalData

const confirmationSlice = createSlice({
  name: 'confirmation',
  initialState,
  reducers: {
    openConfirmationModal: (state, action) => {
      state.isShow = true
      state.modalData = action.payload.modalData
    },
    closeConfirmationModal: (state) => {
      state.isShow = false
      state.modalData = initialState.modalData
    },
    callYes: (state) => {
      state.isShow = false
      state.modalData = initialState.modalData
    },
  },
})

export const { openConfirmationModal, closeConfirmationModal, callYes } =
  confirmationSlice.actions

export default confirmationSlice.reducer
